import {createFileRoute, redirect} from "@tanstack/react-router";
import {isAuthenticated} from "../../../utils/auth.ts";
import Layout from "../../../components/Layouts/Layout.tsx";
import NotesSettingsContent from "../../../components/Settings/NotesSettingsContent.tsx";

export const Route = createFileRoute('/settings/notes/')({
  beforeLoad: async () => {
    if (!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <NotesSettingsContent />
    </Layout>
  );
}
